export default __webpack_public_path__ + "static/media/StagesLarge.159d2f2e.svg";